"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var ExportedPriceHistoryConverter_1 = require("../../../price-list/conversions/ExportedPriceHistoryConverter");

var SelloutTerminationItem_1 = require("../../model/price-termination/SelloutTerminationItem");

var SelloutTerminationItemConverter_1 = require("./SelloutTerminationItemConverter");
/**
 * <p>Implementation of {@link SelloutTerminationItemConverter}.</p>
 *
 * @author JMe
 */


var SelloutTerminationItemConverterImpl =
/*#__PURE__*/
function (_SelloutTerminationIt) {
  _inherits(SelloutTerminationItemConverterImpl, _SelloutTerminationIt);

  function SelloutTerminationItemConverterImpl(validationResultConverter, exportedPriceHistoryConverter) {
    var _this;

    _classCallCheck(this, SelloutTerminationItemConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationItemConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    _this.exportedPriceHistoryConverter = exportedPriceHistoryConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutTerminationItemConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        terminationId: conversions.toDocumentReferenceId(source.terminationId),
        rId: conversions.toDocumentReferenceId(source.rId),
        rName: source.rName,
        pListType: source.pListType,
        workflowType: source.workflowType,
        iId: conversions.toDocumentReferenceId(source.iId),
        pExtId: source.pExtId,
        pId: conversions.toDocumentReferenceId(source.pId),
        pName: source.pName,
        sExtId: source.sExtId,
        sId: conversions.toDocumentReferenceId(source.sId),
        sName: source.sName,
        pValidTo: conversions.fromDate(source.pValidTo),
        pValidToFPrice: source.pValidToFPrice && conversions.fromDate(source.pValidToFPrice),
        fPrice: source.fPrice && conversions.fromBigNumber(source.fPrice),
        pValidFromFPrice: source.pValidFromFPrice && conversions.fromDate(source.pValidFromFPrice),
        exportedPriceHistory: source.exportedPriceHistory && this.exportedPriceHistoryConverter.toDocument(source.exportedPriceHistory, conversions),
        readonly: source.readonly,
        terminate: source.terminate,
        validation: this.validationResultConverter.toDocument(source.validation, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutTerminationItem_1.SelloutTerminationItem(conversions.documentToClassId(source), conversions.asObject(source, 'terminationId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'rId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'rName', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'pListType', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'workflowType', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'iId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'pExtId', function (v) {
        return v;
      }), conversions.asObject(source, 'pId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'pName', function (v) {
        return v;
      }), conversions.asObject(source, 'sExtId', function (v) {
        return v;
      }), conversions.asObject(source, 'sId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'sName', function (v) {
        return v;
      }), conversions.asObject(source, 'pValidTo', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'pValidToFPrice', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'fPrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'pValidFromFPrice', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'exportedPriceHistory', function (v) {
        return _this2.exportedPriceHistoryConverter.toObject(v, conversions);
      }), conversions.asObject(source, 'readonly', function (v) {
        return v;
      }), conversions.asObject(source, 'terminate', function (v) {
        return v;
      }), conversions.asObject(source, 'validation', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SelloutTerminationItemConverterImpl;
}(SelloutTerminationItemConverter_1.SelloutTerminationItemConverter);

SelloutTerminationItemConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter, ExportedPriceHistoryConverter_1.ExportedPriceHistoryConverter])], SelloutTerminationItemConverterImpl);
exports.SelloutTerminationItemConverterImpl = SelloutTerminationItemConverterImpl;